import { RoutesType } from 'Shared/Routes';
import { selectRoutes } from 'Browser/RoutesSelector';
import { Router } from '@solidjs/router';
import { IndexHtml } from 'Shared/IndexHtml';
import { SiteProvider } from 'Shared/SiteProvider';
import {ConfigFactoryCreator} from 'Shared/config/ConfigFactoryCreator';
import { SiteBasics } from 'Common/SiteBasics';
import { BuildBasics } from 'Common/BuildBasics';
import { User } from 'Browser/User';
import { createSignal, ErrorBoundary} from 'solid-js';
import { MetaProvider } from '@solidjs/meta';
import type {initTrpcClient} from 'Browser/Browser';


//TODO test URL queries are preserved for ?fb= shares	Q: can I add an auto test for this?

export type ConnectionToServer = ReturnType<typeof initTrpcClient>;

export interface IRootProps {
	build: BuildBasics,
	site: SiteBasics,
	user: User,
	server: ConnectionToServer,  /* browser only (could put into server too) */
};

interface IIndexHtmlCreatorProps extends IRootProps {
	url: string
};

export function IndexHtmlCreator(props:IIndexHtmlCreatorProps)
{
	const routes = selectRoutes(props.site);
	const mappedRoutes = reformatRoutes(routes);

	return (
		<IndexHtml build={props.build} site={props.site} user={props.user}>
			<Router root={Root(props)} url={props.url}>{mappedRoutes}</Router>
		</IndexHtml>
	);
}

export function createBrowserRouter(params)
{
	return () => <IndexHtmlCreator {...params} />
}

export function createViteBrowserRouter(params)
{
	const routes = selectRoutes(params.site);
	const mappedRoutes = reformatRoutes(routes);

	return () => <Router root={Root(params)} url={params.url}>{mappedRoutes}</Router>;
}


export function Root(props:IRootProps) {
	const venueConfig = (new ConfigFactoryCreator()).create(props.site.key);

	const [user,setUser] = createSignal(props.user);

	/* NOTE: the <ErrorBoundary> does prevent some server crashes. Probably removes the pretty browser errors though. */

//			<ErrorBoundary fallback={(error) => <div>Failure loading.<br/>Error: {error.message}<br/>Stack:<br/><pre>{error.stack}</pre></div>}>

	return (
		(innerProps:{children:JSXElement}) => (
			<MetaProvider>
				<SiteProvider {...props} user={user} setUser={setUser} venueConfig={venueConfig}>
					{innerProps.children}
				</SiteProvider>
			</MetaProvider>
		)
	); 
//			</ErrorBoundary>
}	

/*
	XXX I think terms like 'import('Shared/frontend/homePage/HomePage')' are required to help Rollup create chunks.
		POSSIBLE ALTERNATIVE: https://www.npmjs.com/package/@rollup/plugin-dynamic-import-vars
		OR maybe using manualChunks option, or look at other output options

	I don't know much about this. Sometimes page chunks appear, sometimes not. Maybe Rollup
	is just combining small files.
*/


//XXX THINK ABOUT: maybe delete... but this does allow for more concise routes. Could auto-wrap in lazy() and have a 'nolazy' option
export function reformatRoutes(routes:RoutesType)
{
	const mappedRoutes = [];

	/* Add all routes and redirects to the PageJs router */
	for (const [path,target] of Object.entries(routes)) 
		mappedRoutes.push({path:path,component:target});

	return mappedRoutes;
}

